export default __webpack_public_path__ + "static/media/whaLe.adfefa6b.png";